var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndex = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "2.75 2.75 12.5 12.5",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 7h-3v4h3zm4 1H10v1h2.5zM10 10h2.5v1H10zm5.25-5.5a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75zm-11 .75h9.5v7.5h-9.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndex);
export default ForwardRef;